<template>
  <div class="app-container1">
    <div class="app-map">
      <div class="hearde-form">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="100px">
          <el-form-item label="资源类型" prop="dknm_clue_sourcetype">
            <el-select style="width: 300px" multiple v-model="queryParams.dknm_clue_sourcetype" filterable clearable
              collapse-tags>
              <el-option v-for="area in dknmSourceType" :key="area.number" :value="area.number" :label="area.name" />
            </el-select>
          </el-form-item>
          <el-form-item label=" " label-width="0px">
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"
              v-preventReClick="3000">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery" v-preventReClick="3000">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <HeatLocaMap :heatmapData="heatmapData" @markerClick="markerClick" :loading="isLoggedIn"></HeatLocaMap>
      <el-drawer title="地图信息" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
        <div class="drawer-info">
          <el-descriptions title="标点信息" direction="vertical" :column="2" border>
            <el-descriptions-item label="名称">{{
              infordata.name
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{
              infordata.dknm_person_name
            }}</el-descriptions-item>
            <el-descriptions-item label="规模">{{
              infordata.dknm_scale
            }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{
              infordata.dknm_phonenumber
            }}</el-descriptions-item>
            <el-descriptions-item label="地址">{{
              infordata.dknm_address
            }}</el-descriptions-item>
            <el-descriptions-item label="经度">{{
              infordata.dknm_longitude
            }}</el-descriptions-item>
            <el-descriptions-item label="纬度">{{
              infordata.dknm_latitude
            }}</el-descriptions-item>
            <el-descriptions-item label="母猪存栏数">{{
              infordata.dknm_sow_inventory
            }}</el-descriptions-item>
            <el-descriptions-item label="肥猪存栏数">{{
              infordata.dknm_fat_inventory
            }}</el-descriptions-item>
            <el-descriptions-item label="标点类型">
              <el-tag size="small">{{
                showDknmSourceType(infordata.dknm_clue_sourcetype)
              }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
              infordata.createtime
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import {
  get_all_map_source,
  get_dknm_assistantdata_detail,
} from "@/api/ierp/farm";
import HeatLocaMap from "@/view/components/amaps/HeatLocaMap.vue";
import { getToken } from '@/utils/auth'
export default {
  components: {
    HeatLocaMap,
  },
  data() {
    return {
      heatmapData: [],
      drawer: false,
      direction: "rtl",
      // 查询参数
      queryParams: {
        dknm_clue_sourcetype: ["zylx01", "zylx08"],
      },
      infordata: {
        name: "", //猪场名称
        dknm_address: "东航中心", //地址
        dknm_person_name: "", //联系人
        dknm_phonenumber: "17721865774", //电话
        dknm_scale: "100", //规模
        dknm_clue_sourcetype: [], //类型
        dknm_longitude: "", //精度
        dknm_latitude: "", //纬度度
        dknm_sow_inventory: "",//肥猪存栏数
        dknm_fat_inventory: "",//肥猪存栏数
        createtime: "", // 创建时间
      },
      dknmSourceType: [
        {
          name
            :
            "猪场(外部)",
          number
            :
            "zylx01"
        },
      ],
      isLoggedIn: true,
    };
  },
  created() {


  },
  mounted() {
    const token = getToken();  // 获取 token，检查用户是否已登录
    if (token) {
      this.get_dknm_assistantdata_detail_fn();
      this.getAllMapSource();
    }
  },
  methods: {
    get_dknm_assistantdata_detail_fn() {
      const param = {
        data: {
          group_name: "资源类型",
        },
        pageSize: 20,
        pageNo: 1,
      };
      get_dknm_assistantdata_detail(param).then((res) => {
        if (res.status) {
          this.dknmSourceType = res.data.rows;

          this.queryParams.dknm_clue_sourcetype = ["zylx01", "zylx08"];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getAllMapSource();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.dknm_clue_sourcetype = ["zylx01", "zylx08"];
      this.getAllMapSource();
    },
    showDknmSourceType(arr) {
      // 判断 arr 是否有效
      if (!arr || arr.length === 0) {
        return '';
      }

      return arr.map(e => e.name).join(', ');
    },
    handleClose(done) {
      this.drawer = false;
    },
    getAllMapSource() {
      let allData = []; // 用于存储所有页的数据
      this.heatmapData = []
      this.isLoggedIn = true;
      let param = {
        data: {
          ...this.queryParams,
        },
        pageSize: 10000, // 每页加载1000条数据（调整为合适的数量）
        pageNo: 1,
      };

      const fetchPages = (param) => {
        get_all_map_source(param)
          .then((res) => {
            if (res.status) {
              // 将当前页的数据追加到 allData
              allData = allData.concat(res.data.rows);

              // 分批加载
              if (param.pageNo * param.pageSize < res.data.totalCount) {
                param.pageNo++;
                fetchPages(param);
              } else {
                // 每次获取到一部分数据后就更新一次heatmapData
                this.heatmapData = allData;
                this.isLoggedIn = false;
              }
            } else {
              this.$message.error(res.message);
              this.isLoggedIn = false;
            }
          })
          .catch((error) => {
            console.error("Error occurred while fetching data:", error);
            this.isLoggedIn = false;
          });
      };

      fetchPages(param);
    },
    //地图最小点，点击事件
    markerClick(data) {
      this.drawer = true;
      const {
        name,
        dknm_address,
        dknm_person_name,
        dknm_phonenumber,
        dknm_scale,
        dknm_clue_sourcetype,
        dknm_longitude,
        dknm_latitude,
        dknm_sow_inventory,
        dknm_fat_inventory,
        createtime,
      } = data;
      // 使用参数进行进一步操作
      // 直接更新infodata对象
      this.infordata = {
        name: name,
        dknm_address: dknm_address,
        dknm_person_name: dknm_person_name,
        dknm_phonenumber: dknm_phonenumber,
        dknm_scale: dknm_scale,
        dknm_clue_sourcetype: dknm_clue_sourcetype,
        dknm_longitude: dknm_longitude,
        dknm_latitude: dknm_latitude,
        dknm_sow_inventory: dknm_sow_inventory,
        dknm_fat_inventory: dknm_fat_inventory,
        createtime: createtime,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container1 {
  height: 100vh;
  /* 使用视口高度确保容器占满屏幕 */
  width: 100%;
  display: flex;
  flex-direction: column;
  /* 确保子元素垂直排列 */
}

.app-map {
  flex: 1;
  /* 确保地图部分占据剩余的空间 */
  overflow: hidden;
  /* 防止溢出 */
}

.hearde-form {
  height: 100px;
  /* 增加表单区域高度 */
  width: 100%;
  padding-top: 20px;
  overflow: auto;
  /* 如果表单内容过多，可以滚动 */
  display: flex;
  align-items: anchor-center;
}

.drawer-info {
  padding: 10px;
}
</style>
